import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const ResetPassword = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error(t('resetPassword.passwordMismatch'));
      return;
    }

    if (formData.password.length < 6) {
      toast.error(t('resetPassword.passwordTooShort'));
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/auth/reset-password`, {
        token: token,
        new_password: formData.password
      });
      toast.success(t('resetPassword.success'));
      setTimeout(() => navigate('/bess/login'), 2000);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('resetPassword.errorGeneric'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="card animate-fadeIn">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-slate-900">{t('resetPassword.title')}</h2>
            <p className="mt-2 text-sm text-slate-600">
              {t('resetPassword.subtitle')}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="password">{t('resetPassword.newPassword')}</Label>
              <Input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                placeholder={t('resetPassword.newPasswordPlaceholder')}
              />
            </div>

            <div>
              <Label htmlFor="confirmPassword">{t('resetPassword.confirmPassword')}</Label>
              <Input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                required
                placeholder={t('resetPassword.confirmPasswordPlaceholder')}
              />
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-sm text-yellow-800" dangerouslySetInnerHTML={{ __html: t('resetPassword.expiryNotice') }} />
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={loading}
            >
              {loading ? t('resetPassword.submitLoading') : t('resetPassword.submit')}
            </Button>

            <div className="text-center">
              <Link to="/bess/login" className="text-sm text-blue-600 hover:text-blue-500">
                {t('resetPassword.backToLogin')}
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
